module.exports = __webpack_public_path__ + "img/24_47.87dee5aa.png";